import { MessageInitShape } from "@bufbuild/protobuf";
import { UseQueryOptions, useQuery } from "@connectrpc/connect-query";

import { listAvailableLogFields } from "../gen/github.com/pomerium/pomerium/pkg/grpc/config/config-ConfigService_connectquery";

type Input = MessageInitShape<typeof listAvailableLogFields.input>;
type Options = UseQueryOptions<typeof listAvailableLogFields.output>;
const useListAvailableLogFields = (input?: Input, options?: Options) => {
  return useQuery(listAvailableLogFields, { ...input }, { ...options });
};
export default useListAvailableLogFields;
